import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import _isFunction from "lodash/isFunction";
import _omit from "lodash/omit";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import React, { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Table, GivenPaymentsTableHeader } from 'components';
import { showApiError } from 'utils';
import { getAllPaymentsBreakdown } from 'services';
import { tableWrapTabs } from 'styles';
import AllPaymentsValuesList from './AllPaymentsValuesList';
import { allPaymentsBreakdownColumns } from './config';
import { jsx as ___EmotionJSX } from "@emotion/react";

var rowWrap = function rowWrap(theme) {
  return {
    transition: 'background-color .3s ease-in-out',
    borderBottom: "1px solid ".concat(theme.gray100),
    '&:last-of-type': {
      borderBottom: 'none'
    },
    '&:hover': {
      backgroundColor: theme.gray50
    }
  };
};

var detailWrap = {
  padding: '0 1.5em 1.2em'
};

var detailGrid = function detailGrid(theme) {
  return {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    border: "1px solid ".concat(theme.gray100),
    backgroundColor: theme.white,
    '@media (max-width: 900px)': {
      gridTemplateColumns: 'repeat(2, 1fr)'
    },
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr'
    }
  };
};

var detailSection = function detailSection(theme) {
  return {
    padding: '1em 1.2em',
    borderRight: "1px solid ".concat(theme.gray100),
    '&:last-of-type': {
      borderRight: 'none'
    },
    '@media (max-width: 900px)': {
      '&:nth-of-type(2)': {
        borderRight: 'none'
      },
      '&:nth-of-type(n+3)': {
        borderTop: "1px solid ".concat(theme.gray100)
      }
    },
    '@media (max-width: 600px)': {
      borderRight: 'none',
      borderBottom: "1px solid ".concat(theme.gray100),
      '&:last-of-type': {
        borderBottom: 'none'
      }
    }
  };
};

var detailSectionTitle = function detailSectionTitle(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.4em',
    marginBottom: '0.7em',
    '& i': {
      fontSize: '1.3rem',
      color: theme.primary
    },
    '& span': {
      fontSize: '1.1rem',
      fontWeight: 600,
      color: theme.gray400,
      textTransform: 'uppercase',
      letterSpacing: '0.04em'
    }
  };
};

var detailRow = function detailRow(theme) {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.22em 0',
    '& .lbl': {
      fontSize: '1.2rem',
      color: theme.gray400
    },
    '& .val': {
      fontSize: '1.2rem',
      fontWeight: 600,
      color: theme.gray700
    }
  };
};

var fmt = function fmt(val, cur) {
  return "".concat(val !== null && val !== void 0 ? val : '--', " ").concat(cur);
};

var DetailCard = function DetailCard(_ref) {
  var _row$currency;

  var row = _ref.row;
  var cur = (_row$currency = row.currency) !== null && _row$currency !== void 0 ? _row$currency : '';
  return ___EmotionJSX("div", {
    css: detailWrap
  }, ___EmotionJSX("div", {
    css: detailGrid
  }, ___EmotionJSX("div", {
    css: detailSection
  }, ___EmotionJSX("div", {
    css: detailSectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-check-circle"
  }), ___EmotionJSX("span", null, "\u0421\u044A\u0431\u0440\u0430\u043D\u0438")), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u0413\u043B\u0430\u0432\u043D\u0438\u0446\u0430"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_payed_principal, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u041B\u0438\u0445\u0432\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_payed_interest, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u041D\u0430\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u043D\u0438 \u043B\u0438\u0445\u0432\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_payed_penalty, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u0422\u043E\u0442\u0430\u043B \u043B\u0438\u0445\u0432\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_payed_interest_all, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u0422\u0430\u043A\u0441\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_payed_fee, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u041E\u0431\u0449\u043E \u0441\u044A\u0431\u0440\u0430\u043D\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_payed_amount, cur)))), ___EmotionJSX("div", {
    css: detailSection
  }, ___EmotionJSX("div", {
    css: detailSectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-exclamation-triangle"
  }), ___EmotionJSX("span", null, "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u0438")), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u0413\u043B\u0430\u0432\u043D\u0438\u0446\u0430"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_late_principal, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u041B\u0438\u0445\u0432\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_late_interest, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u041D\u0430\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u043D\u0438 \u043B\u0438\u0445\u0432\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_late_penalty, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u0422\u043E\u0442\u0430\u043B \u043B\u0438\u0445\u0432\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_late_interest_all, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u0422\u0430\u043A\u0441\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_late_fee, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u041E\u0431\u0449\u043E \u043F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_late_amount, cur)))), ___EmotionJSX("div", {
    css: detailSection
  }, ___EmotionJSX("div", {
    css: detailSectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-clock"
  }), ___EmotionJSX("span", null, "\u0411\u044A\u0434\u0435\u0449\u0438")), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u0413\u043B\u0430\u0432\u043D\u0438\u0446\u0430"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_future_principal, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u041B\u0438\u0445\u0432\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_future_interest, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u041D\u0430\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u043D\u0438 \u043B\u0438\u0445\u0432\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_future_penalty, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u0422\u043E\u0442\u0430\u043B \u043B\u0438\u0445\u0432\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_future_interest_all, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u0422\u0430\u043A\u0441\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_future_fee, cur))), ___EmotionJSX("div", {
    css: detailRow
  }, ___EmotionJSX("span", {
    className: "lbl"
  }, "\u041E\u0431\u0449\u043E \u0431\u044A\u0434\u0435\u0449\u0438"), ___EmotionJSX("span", {
    className: "val"
  }, fmt(row.total_future_amount, cur))))));
};

DetailCard.propTypes = {
  row: PropTypes.object
};

var AllPaymentsBreakdown = function AllPaymentsBreakdown(_ref2) {
  var franchises = _ref2.franchises;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      totalData = _useState2[0],
      setTotalData = _useState2[1];

  var fetchAllPaymentsBreakdown = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tableOptions) {
      var _yield$getAllPayments, _yield$getAllPayments2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllPaymentsBreakdown(tableOptions);

            case 2:
              _yield$getAllPayments = _context.sent;
              _yield$getAllPayments2 = _slicedToArray(_yield$getAllPayments, 2);
              res = _yield$getAllPayments2[0];
              err = _yield$getAllPayments2[1];

              if (!err) {
                _context.next = 9;
                break;
              }

              showApiError(err);
              return _context.abrupt("return", [null, err]);

            case 9:
              setTotalData(_omit(res, 'credits_data'));
              return _context.abrupt("return", [res === null || res === void 0 ? void 0 : res.credits_data, null]);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  var filterBar = useMemo(function () {
    return function (data) {
      return ___EmotionJSX(GivenPaymentsTableHeader, _extends({}, data, {
        showStartEndDateFilter: true,
        franchisesList: franchises
      }));
    };
  }, [franchises]);
  var renderRow = useCallback(function (_ref4) {
    var _row$_table;

    var row = _ref4.row,
        rowClassName = _ref4.rowClassName,
        columnClassName = _ref4.columnClassName,
        columns = _ref4.columns;
    return ___EmotionJSX("div", {
      css: rowWrap,
      key: (_row$_table = row._table) === null || _row$_table === void 0 ? void 0 : _row$_table.uuid
    }, ___EmotionJSX("div", {
      css: rowClassName(false)
    }, columns.map(function (col, j) {
      return ___EmotionJSX("div", {
        key: "col-".concat(j),
        css: columnClassName(col)
      }, _isFunction(col.render) ? col.render(row) : row[col.value]);
    })), ___EmotionJSX(DetailCard, {
      row: row
    }));
  }, []);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    css: tableWrapTabs
  }, ___EmotionJSX(AllPaymentsValuesList, {
    data: totalData,
    currency: totalData === null || totalData === void 0 ? void 0 : totalData.currency
  }), ___EmotionJSX(Table, {
    hasPagination: true,
    getDataMethod: fetchAllPaymentsBreakdown,
    columns: allPaymentsBreakdownColumns,
    emptyMessage: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u0437\u0430\u043F\u0438\u0441\u0438!",
    filterBar: filterBar,
    renderRow: renderRow,
    margin: "0 2em",
    pageSize: 20
  })));
};

AllPaymentsBreakdown.propTypes = {
  franchises: PropTypes.array
};
export default AllPaymentsBreakdown;